import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-458e63cc")

_pushScopeId("data-v-458e63cc")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("公告")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("通知")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("升级公告（显示登录页）")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("一直有效")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("截止时间")
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("公开全部（不含禁用企业）")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("白名单（指定企业）")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("黑名单（不接收企业）")
const _hoisted_10 = {
  key: 0,
  style: {"margin-top":"10px","width":"80%","min-width":"600px"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("开启")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.title,
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "900px",
    "destroy-on-close": "",
    "before-close": _ctx.handleClose
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_13, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.formData,
        rules: _ctx.rules,
        "label-width": "110px",
        size: "small"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "类型",
            prop: "type"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.type = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, { label: 3 }, {
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "内容",
            prop: "content"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: _ctx.formData.content,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.content = $event)),
                placeholder: "请输入内容",
                maxlength: "2000",
                "show-word-limit": "",
                rows: 12
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "截止有效日期",
            prop: "deadlineType"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.deadlineType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.deadlineType = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, {
                    label: 1,
                    disabled: _ctx.isUpgradeNotice
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.formData.deadlineType === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.deadline,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.deadline = $event)),
                      type: "datetime",
                      placeholder: "选择日期时间",
                      "value-format": "YYYY-MM-DD HH:mm",
                      style: {"width":"200px"}
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "范围",
            prop: "scope"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.scope,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.scope = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 2,
                    disabled: _ctx.isUpgradeNotice
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_radio, {
                    label: 3,
                    disabled: _ctx.isUpgradeNotice
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.formData.scope !== 1)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.enterprises,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.enterprises = $event)),
                      multiple: "",
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "请输入企业名称搜索",
                      "remote-method": _ctx.remoteMethod,
                      loading: _ctx.loading,
                      style: {"width":"100%"},
                      size: "large",
                      disabled: _ctx.isUpgradeNotice && (_ctx.formData.scope === 2 || _ctx.formData.scope === 3)
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.enterpriseOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "remote-method", "loading", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "相关链接",
            prop: "url"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.url,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.url = $event)),
                placeholder: "系统内地址或外部地址",
                maxlength: "128",
                "show-word-limit": "",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.status = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withId(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 0 }, {
                    default: _withId(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})